import { render } from "./AddMailerRecordForm.vue?vue&type=template&id=51fa9e4c"
import script from "./AddMailerRecordForm.vue?vue&type=script&lang=js"
export * from "./AddMailerRecordForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__